export default "__VITE_ASSET__DgEz1QbD__"